import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import moment from 'moment'

import { AppDispatch } from '@src/store/store'
import { getCoupons } from '@src/store/ducks/coupons/thunks'
import {
  selectCouponsIsLoading, selectCouponsIsNext, selectCouponsList, selectCouponsTotal,
} from '@src/store/ducks/coupons/selectors'
import { resetCoupons } from '@src/store/ducks/coupons/reducer'
import { Button } from '@src/components/Button/Button'
import { Preloader } from '@src/components/common/Preloader/Preloader'
import { selectProfile } from '@src/store/ducks/user/selectors'
import { NavLink } from 'react-router-dom'
import { getProfile } from '@src/store/ducks/user/thunks'
import style from './Coupons.module.scss'

export const Coupons = () => {
  const dispatch = useDispatch<AppDispatch>()
  const total = useSelector(selectCouponsTotal)
  const couponsList = useSelector(selectCouponsList)
  const isLoading = useSelector(selectCouponsIsLoading)
  const isNext = useSelector(selectCouponsIsNext)
  const profile = useSelector(selectProfile)
  const [page, setPage] = useState(1)

  useEffect(() => {
    dispatch(getProfile())
  }, [dispatch])

  useEffect(() => {
    if (profile.isPromotionalGames) {
      dispatch(getCoupons(page))
    }
  }, [dispatch, page, profile.isPromotionalGames])

  useEffect(() => () => {
    dispatch(resetCoupons())
  }, [dispatch])

  return (
    <div>
      {profile.isPromotionalGames && profile.phone && profile.surname && profile.name && profile.birthday && profile.locality ? (
        <Preloader loading={isLoading && !couponsList.length} center>
          <div className={style.total}>
            Имеется игровых кодов:
            {' '}
            <span className="сSecondary">{total}</span>
          </div>

          <div className={style.tableHeader}>
            <div className={cn(style.tableRow)}>
              <div className={style.tdGameNumber}>Номер игрового кода</div>
              <div className={style.tdNumber}>Уникальный номер</div>
              <div className={style.tdDate}>Дата покупки</div>
              <div className={style.tdStatus}>Статус игрового кода</div>
            </div>
          </div>

          <div className={style.tableBody}>
            {couponsList.map((coupon) => (
              <div className={cn(style.tableRow, style.tableBodyRow)} key={coupon.id}>
                <div className={style.tdGameNumber}>
                  <div className={style.mobileTableTitle}>Номер игрового кода</div>
                  {(`0000000${coupon.number}`).slice(-8)}
                </div>
                <div className={style.tdNumber}>
                  <div className={style.mobileTableTitle}>Уникальный номер</div>
                  {coupon.gameCode}
                </div>
                <div className={style.tdDate}>
                  <div className={style.mobileTableTitle}>Дата покупки</div>
                  {moment(coupon.issueDate).format('DD.MM.yyyy')}
                </div>
                <div className={style.tdStatus}>
                  <div className={style.mobileTableTitle}>Статус игрового кода</div>
                  <div className={style.statusSuccess}>
                    Участвует в розыгрыше
                    {' '}
                    {coupon.numberTour}
                    {' '}
                    тур, суперигра
                  </div>
                </div>
              </div>
            ))}
          </div>

          {isNext && (
            <div className={style.btnContainer}>
              <Button
                className={style.btnSize}
                type="secondary"
                onClickFunc={() => setPage(page + 1)}
                loading={isLoading}
              >
                Показать больше
              </Button>
            </div>
          )}
        </Preloader>
      ) : (
        <div className={style.noGame}>
          Вы не участвуете в рекламной игре, подтвердить участие вы можете в
          <NavLink to="/lk/profile/" className={style.noGameLink}> личных данных</NavLink>
        </div>
      )}

    </div>
  )
}
